module.exports = __webpack_public_path__ + "media/images/woods.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/woods.jpg
// module id = 75
// module chunks = 0